module.exports = __webpack_public_path__ + "img/search_place.c440fda0.png";